import axios from "axios";

// wrong location
export const createPlanSubmissionFromNewProject = (payload) =>
  axios.post(`/ess/api/e-counter/plan-submission/new-project`, payload);

// wrong location
export const createPlanSubmissionFromExistingProject = (payload) =>
  axios.post(`/ess/api/e-counter/plan-submission/exist-project`, payload);
